import { OnInit, Component } from "@angular/core";

@Component({
    selector: "custom-error-page",
    templateUrl: "./custom-error-page.component.html",
    standalone: false
})
export class CustomErrorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
